// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__m_q94","label":"styles_label__2H8Gp"};